import {CardPatientGoalComponent} from './card-patient-goal/card-patient-goal.component';
import {ProgressBodyComponent} from './progress-body/progress-body.component';
import {LicensesComponent} from './licenses/licenses.component';
import {ProgressHeartComponent} from './progress-heart/progress-heart.component';
import {ThermometerComponent} from './thermometer/thermometer.component';
import {RecordHistoryMyExperienceComponent} from './record-history-my-experience/record-history-my-experience.component';
import {PhonesComponent} from './phones/phones.component';
import {CalorieTrackingComponent} from './calorie-tracking/calorie-tracking.component';
import {RecordHistoryPhysicalActivityComponent} from './record-history-physical-activity/record-history-physical-activity.component';
import {MacronutrientDistributionComponent} from './macronutrient-distribution/macronutrient-distribution.component';
import {ImportantInfoPatientComponent} from './important-info-patient/important-info-patient.component';
import {ViewNotesComponent} from './view-notes/view-notes.component';
import {ImageSelectorComponent} from './image-selector/image-selector.component';
import {AppointmentsTableComponent} from './appointments-table/appointments-table.component';
import {ConsultationComponent} from './consultation/consultation.component';
import {RouterModule} from '@angular/router';
import {DateComponent} from './date-component/date-component.component';
import {NgModule} from '@angular/core';
import {ExternalModule} from '../external.module';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DropdownMenuComponent} from './dropdown-menu/dropdown-menu.component';
import {DateListComponent} from './date-list/date-list.component';
import {LoaderComponent} from './loader/loader.component';
import {UserInfoComponent} from './user-info/user-info.component';
import {MessageFieldComponent} from './message-field/message-field.component';
import {DirectivesModule} from '../directives/directives.module';
import {InputNumberComponent} from './input-number/input-number.component';
import {DateIndicatorComponent} from './date-indicator/date-indicator.component';
import {ConsultationsDetailsComponent} from './consultations-details/consultations-details.component';
import {AvatarGroupComponent} from './avatar-group/avatar-group.component';
import {PipesModule} from '../pipes/pipes.module';
import {ScrollingModule} from '@angular/cdk/scrolling';
import {CardAssistantComponent} from './card-assistant/card-assistant.component';
import {ModalCreateAppointmentComponent} from './modal-create-appointment/modal-create-appointment.component';
import {NewMeasurementComponent} from './new-measurement/new-measurement.component';
import {CardIconTextComponent} from './card-icon-text/card-icon-text.component';
import {CardNoteAppointmentComponent} from './card-note-appointment/card-note-appointment.component';
import {NgxChartsModule} from '@swimlane/ngx-charts';
import {LateralMenuModulesComponent} from './lateral-menu-modules/lateral-menu-modules.component';
import {CardMealPlanComponent} from './card-meal-plan/card-meal-plan.component';
import {CardPatientComponent} from './card-patient/card-patient.component';
import {CardDateAppointmentComponent} from './card-date-appointment/card-date-appointment.component';
import {AllMeasurementsTableComponent} from './all-measurements-table/all-measurements-table.component';
import {NzPipesModule} from 'ng-zorro-antd/pipes';
import {NzDividerModule} from 'ng-zorro-antd/divider';
import {NzInputNumberModule} from 'ng-zorro-antd/input-number';
import {PhoneSectionComponent} from './phone-section/phone-section.component';
import {AddressSectionComponent} from './address-section/address-section.component';
import {ModalCreateBranchComponent} from './modal-create-branch/modal-create-branch.component';
import {SkeletonTemplateComponent} from './skeleton-template/skeleton-template.component';
import {ConcatPropertiesComponent} from './concat-properties/concat-properties.component';
import {ModalCreatePatientComponent} from './modal-create-patient/modal-create-patient.component';
import {CardExpertComponent} from './card-expert/card-expert.component';
import {ModalCreateExpertComponent} from './modal-create-expert/modal-create-expert.component';
import {SetHoursComponent} from './set-hours/set-hours.component';
import {SetHoursExeptionComponent} from './set-hours-exeption/set-hours-exeption.component';
import {SetHoursAndExceptionsComponent} from './set-hours-and-exeptions/set-hours-and-exceptions.component';
import {ModalAddPatientAppointmentComponent} from './modal-add-patient-appointment/modal-add-patient-appointment.component';
import {ModalAddExpertAppointmentComponent} from './modal-add-expert-appointment/modal-add-expert-appointment.component';
import {ModalCancelAppointmentComponent} from './modal-cancel-appointment/modal-cancel-appointment.component';
import {ModalRescheduleAppointmentComponent} from './modal-reschedule-appointment/modal-reschedule-appointment.component';
import {PaginatorComponent} from './paginator/paginator.component';
import {ModalCreateNoteComponent} from './modal-create-note/modal-create-note.component';
import {AngularEditorModule} from '@kolkov/angular-editor';
import {RecordHistoryNutritionalComponent} from './record-history-nutritional/record-history-nutritional.component';
import {ModalShowAppointmentComponent} from './modal-show-appointment/modal-show-appointment.component';
import {AppointmentDetailsComponent} from './appointment-details/appointment-details.component';
import {RecordHistoryPersonalMedicalComponent} from './record-history-personal-medical/record-history-personal-medical.component';
import {LevelSecurityPasswordCheckerComponent} from './level-security-password-checker/level-security-password-checker.component';
import {UserRegisterConfirmationComponent} from './user-register-confirmation/user-register-confirmation.component';
import {UserRegisterHowClinicComponent} from './user-register-how-clinic/user-register-how-clinic.component';
import {UserRegisterInformationComponent} from './user-register-information/user-register-information.component';
import {UserRegisterHabitsComponent} from './user-register-habits/user-register-habits.component';
import {UserRegisterPrivacyComponent} from './user-register-privacy/user-register-privacy.component';
import {ClinicRegisterAddressComponent} from './clinic-register-address/clinic-register-address.component';
import {ClinicRegisterContactComponent} from './clinic-register-contact/clinic-register-contact.component';
import {ClinicRegisterClinicComponent} from './clinic-register-clinic/clinic-register-clinic.component';
import {ModalCreateServiceComponent} from './modal-create-service/modal-create-service.component';
import {NgScrollbarModule} from 'ngx-scrollbar';
import {OldAppointmentsTableComponent} from './old-appointments-table/old-appointments-table.component';
import {ClinicRegisterPlanComponent} from './clinic-register-plan/clinic-register-plan.component';
import {NgxEditorModule} from 'ngx-editor';
import {RecordHistoryHabitsComponent} from './record-history-habits/record-history-habits.component';
import {AppointmentPageComponent} from './appointment-page/appointment-page.component';
import {ModalExpertNotAvailableComponent} from './modal-expert-not-available/modal-expert-not-available.component';
import {CardMealPlanKanbanComponent} from './card-meal-plan-kanban/card-meal-plan-kanban.component';
import {RecordHistoryFamilialMedicalComponent} from './record-history-familial-medical/record-history-familial-medical.component';
import {NotFoundTemplateComponent} from './not-found-template/not-found-template.component';
import {CardIngredientComponent} from './card-ingredient/card-ingredient.component';
import {ModalWaitSubscriptionComponent} from './modal-wait-subscription/modal-wait-subscription.component';
import {ModalWrongSubscriptionComponent} from './modal-wrong-subscription/modal-wrong-subscription.component';
import {ModalNotAllowedBySuscriptionComponent} from './modal-not-allowed-by-suscription/modal-not-allowed-by-suscription.component';
import {ModalChangePlanComponent} from './modal-change-plan/modal-change-plan.component';
import {ModalCancelPlanComponent} from './modal-cancel-plan/modal-cancel-plan.component';
import {ModalViewFileComponent} from './modal-view-file/modal-view-file.component';
import {ModalNotAllowedAccessComponent} from './modal-not-allowed-access/modal-not-allowed-access.component';
import {ModalUpdatePlanComponent} from './modal-update-plan/modal-update-plan.component';
import {NgxDocViewerModule} from 'ngx-doc-viewer';
import {CardMealPlanEmptyKanbanComponent} from './card-meal-plan-empty-kanban/card-meal-plan-empty-kanban.component';
import {MacronutrientChartsComponent} from './macronutrient-charts/macronutrient-charts.component';
import {MicronutrientListComponent} from './micronutrient-list/micronutrient-list.component';
import {CardMealPlansComponent} from './card-meal-plans/card-meal-plans.component';
import {FormIngredientComponent} from './form-ingredient/form-ingredient.component';
import {HistorialMealPlanTableComponent} from './historial-meal-plan-table/historial-meal-plan-table.component';
import {OptionsMealPlanComponent} from './options-meal-plan/options-meal-plan.component';
import {CardMealPlanToAppointmentComponent} from './card-meal-plan-to-appointment/card-meal-plan-to-appointment.component';
import {ConsultationInformationComponent} from './consultation-information/consultation-information.component';
import {ConsultationFileComponent} from './consultation-file/consultation-file.component';
import {ConsultationMeasurementComponent} from './consultation-measurement/consultation-measurement.component';
import {ConsultationDiagnosisComponent} from './consultation-diagnosis/consultation-diagnosis.component';
import {ConsultationOrientationComponent} from './consultation-orientation/consultation-orientation.component';
import {UserRegisterShareDataComponent} from './user-register-share-data/user-register-share-data.component';
import {AvatarUserComponent} from './avatar-user/avatar-user.component';
import {
  BookmarkViewService,
  LinkAnnotationService,
  MagnificationService,
  NavigationService,
  PdfViewerModule,
  PrintService,
  TextSearchService,
  TextSelectionService,
  ThumbnailViewService,
  ToolbarService
} from '@syncfusion/ej2-angular-pdfviewer';
import {L10n} from '@syncfusion/ej2-base';
import {CardAppointmentRequestComponent} from './card-appointment-request/card-appointment-request.component';
import {AppointmentRequestsComponent} from './appointment-requests/appointment-requests.component';
import {
  RecordHistoryNutritionalPhysicalExaminationComponent
} from './record-history-nutritional-physical-examination/record-history-nutritional-physical-examination.component';
import {UploadFilesComponent} from './upload-files/upload-files.component';
import {RecordHistoryEnvironmentAffectivityComponent} from './record-history-environment-affectivity/record-history-environment-affectivity.component';
import {RecordHistorySleepComponent} from './record-history-sleep/record-history-sleep.component';
import {RecordHistoryAttitudeComponent} from './record-history-attitude/record-history-attitude.component';
import {BasicFormulasComponent} from './basic-formulas/basic-formulas.component';
import {ComplexFormulasComponent} from './complex-formulas/complex-formulas.component';
import {ImcTableComponent} from './imc-table/imc-table.component';
import {RecordHistoryBiochemistsComponent} from './record-history-biochemists/record-history-biochemists.component';
import {NgxMasonryModule} from 'ngx-masonry';
import {BodyTypeComponent} from './body-type/body-type.component';
import {CardTemplateComponent} from './card-template/card-template.component';
import {MobileMenuComponent} from './mobile-menu/mobile-menu.component';
import {CouponComponent} from './coupon/coupon.component';
import {ClinicRegisterBetaUserComponent} from './clinic-register-beta-user/clinic-register-beta-user.component';
import {RequiredMeasurementsTranslatePipe} from '../pipes/required-measurements-translate/required-measurements-translate.pipe';
import {VerifyRequiredMeasurementsPipe} from '../pipes/verify-required-measurements/verify-required-measurements.pipe';
import {ConsultationFormulasComponent} from './consultation-formulas/consultation-formulas.component';
import {TourCardComponent} from './tour-card/tour-card.component';
import {ToolbarMealPlanComponent} from './toolbar-meal-plan/toolbar-meal-plan.component';
import {MealPlanEditorComponent} from './meal-plan-editor/meal-plan-editor.component';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {CNutrientTableComponent} from './c-nutrient-table/c-nutrient-table.component';
import {CMacronutrientInfoComponent} from './c-macronutrient-info/c-macronutrient-info.component';
import {CustomCalorieTrackingComponent} from './custom-calorie-tracking/custom-calorie-tracking.component';
import {RecordMiniSphereComponent} from './record-mini-sphere/record-mini-sphere.component';
import {IngredientSelectorComponent} from './ingredient-selector/ingredient-selector.component';
import {CompleteSphereComponent} from './complete-sphere/complete-sphere.component';
import {MiniSphereComponent} from './mini-sphere/mini-sphere.component';
import {CompleteRecordSphereComponent} from './complete-record-sphere/complete-record-sphere.component';
import {DownloadPatientTemplateComponent} from './download-patient-template/download-patient-template.component';
import {IccImcRelationTableComponent} from './icc-imc-relation-table/icc-imc-relation-table.component';
import {ModalAddAllergyComponent} from './modal-add-allergy/modal-add-allergy.component';
import { MealTimingTableComponent } from './meal-timing-table/meal-timing-table.component';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { FoodGroupFormComponent } from './food-group-form/food-group-form.component';
import { IndividualFormComponent } from './individual-form/individual-form.component';
import { InstructionFormComponent } from './instruction-form/instruction-form.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { StepsProgressBarComponent } from './steps-progress-bar/steps-progress-bar.component';
import { CategoryRequirementsComponent } from './category-requirements/category-requirements.component';

// tslint:disable:object-literal-key-quotes
L10n.load({
  'es-MX': {
    'PdfViewer': {
      'PdfViewer': 'Visualizador de pdf',
      'Cancel': 'Cancelar',
      'Download file': 'Descargar archivo',
      'Download': 'Descargar',
      'Enter Password': 'Ingresa contraseña',
      'File Corrupted': 'Archivo corrupto',
      'File Corrupted Content': 'Contenido del archivo está corrupo',
      'Fit Page': 'Ajustar página',
      'Fit Width': 'Ajustar ancho',
      'Automatic': 'Automático',
      'Go To First Page': 'Ir a la primera página',
      'Invalid Password': 'Contraseña inválida',
      'Next Page': 'Siguiente página',
      'OK': 'Bien',
      'Open': 'Abrir',
      'Page Number': 'Número de página',
      'Previous Page': 'Página anterior',
      'Go To Last Page': 'Ir a la última página',
      'Zoom': 'Zoom',
      'Zoom In': 'Acercar',
      'Zoom Out': 'Alejar',
      'Page Thumbnails': 'Miniaturas de página',
      'Bookmarks': 'Marcas',
      'Print': 'Imprimir',
      'Password Protected': 'Contraseña protegida',
      'Copy': 'Copiar',
      'Text Selection': 'Selección de texto',
      'Panning': 'Panorámica',
      'Text Search': 'Buscar texto',
      'Find in document': 'Buscar en el documento',
      'Match case': 'Coincidencias',
      'Apply': 'Aplicar',
      'GoToPage': 'Ir a la página',
      'No matches': 'No hay coincidencias',
      'No Text Found': 'Texto no encontrado',
      'Undo': 'Deshacer',
      'Redo': 'Rehacer',
      'Annotation': 'Anotación',
      'Server error': 'Error de servidor'
    }
  }
});

const components = [
  DropdownMenuComponent,
  DateComponent,
  DateListComponent,
  LoaderComponent,
  UserInfoComponent,
  MessageFieldComponent,
  InputNumberComponent,
  ConsultationComponent,
  ConsultationInformationComponent,
  ConsultationFileComponent,
  ConsultationMeasurementComponent,
  ConsultationDiagnosisComponent,
  ConsultationOrientationComponent,
  DateIndicatorComponent,
  ConsultationsDetailsComponent,
  AvatarGroupComponent,
  AppointmentsTableComponent,
  CardAssistantComponent,
  CardIconTextComponent,
  CardDateAppointmentComponent,
  ModalCreateAppointmentComponent,
  NewMeasurementComponent,
  CardNoteAppointmentComponent,
  ImageSelectorComponent,
  LateralMenuModulesComponent,
  CardMealPlanComponent,
  CardPatientComponent,
  AllMeasurementsTableComponent,
  PhoneSectionComponent,
  AddressSectionComponent,
  ModalCreateBranchComponent,
  SkeletonTemplateComponent,
  ConcatPropertiesComponent,
  ModalCreatePatientComponent,
  CardExpertComponent,
  ModalCreateExpertComponent,
  SetHoursComponent,
  SetHoursExeptionComponent,
  SetHoursAndExceptionsComponent,
  ModalAddPatientAppointmentComponent,
  ModalAddExpertAppointmentComponent,
  ModalCancelAppointmentComponent,
  ModalRescheduleAppointmentComponent,
  PaginatorComponent,
  LevelSecurityPasswordCheckerComponent,
  ModalCreateNoteComponent,
  RecordHistoryNutritionalComponent,
  ModalShowAppointmentComponent,
  AppointmentDetailsComponent,
  RecordHistoryPersonalMedicalComponent,
  UserRegisterConfirmationComponent,
  UserRegisterHowClinicComponent,
  UserRegisterInformationComponent,
  UserRegisterHabitsComponent,
  UserRegisterPrivacyComponent,
  ClinicRegisterAddressComponent,
  ClinicRegisterContactComponent,
  ClinicRegisterClinicComponent,
  ClinicRegisterPlanComponent,
  ModalCreateServiceComponent,
  OldAppointmentsTableComponent,
  RecordHistoryHabitsComponent,
  AppointmentPageComponent,
  ModalExpertNotAvailableComponent,
  CardMealPlanKanbanComponent,
  RecordHistoryFamilialMedicalComponent,
  NotFoundTemplateComponent,
  CardIngredientComponent,
  ModalWaitSubscriptionComponent,
  ModalWrongSubscriptionComponent,
  ModalNotAllowedBySuscriptionComponent,
  ModalChangePlanComponent,
  ModalCancelPlanComponent,
  ModalViewFileComponent,
  ModalNotAllowedAccessComponent,
  ModalUpdatePlanComponent,
  CardMealPlanEmptyKanbanComponent,
  MacronutrientChartsComponent,
  MicronutrientListComponent,
  CardMealPlansComponent,
  FormIngredientComponent,
  HistorialMealPlanTableComponent,
  OptionsMealPlanComponent,
  CardMealPlanToAppointmentComponent,
  UserRegisterShareDataComponent,
  AvatarUserComponent,
  ViewNotesComponent,
  ImportantInfoPatientComponent,
  MacronutrientDistributionComponent,
  CardAppointmentRequestComponent,
  AppointmentRequestsComponent,
  RecordHistoryPhysicalActivityComponent,
  RecordHistoryNutritionalPhysicalExaminationComponent,
  UploadFilesComponent,
  RecordHistoryEnvironmentAffectivityComponent,
  RecordHistorySleepComponent,
  RecordHistoryAttitudeComponent,
  CalorieTrackingComponent,
  BasicFormulasComponent,
  ComplexFormulasComponent,
  ImcTableComponent,
  RecordHistoryBiochemistsComponent,
  PhonesComponent,
  RecordHistoryMyExperienceComponent,
  ThermometerComponent,
  BodyTypeComponent,
  ProgressHeartComponent,
  LicensesComponent,
  ProgressBodyComponent,
  CardPatientGoalComponent,
  CardTemplateComponent,
  MobileMenuComponent,
  CouponComponent,
  ClinicRegisterBetaUserComponent,
  ConsultationFormulasComponent,
  TourCardComponent,
  ToolbarMealPlanComponent,
  MealPlanEditorComponent,
  CNutrientTableComponent,
  CMacronutrientInfoComponent,
  CustomCalorieTrackingComponent,
  RecordMiniSphereComponent,
  IngredientSelectorComponent,
  MiniSphereComponent,
  CompleteSphereComponent,
  CompleteRecordSphereComponent,
  DownloadPatientTemplateComponent,
  IccImcRelationTableComponent,
  ModalAddAllergyComponent,
  MealTimingTableComponent,
  FoodGroupFormComponent,
  IndividualFormComponent,
  InstructionFormComponent,
  StepsProgressBarComponent,
  CategoryRequirementsComponent
];

@NgModule({
  declarations: components,
    imports: [
        CommonModule,
        RouterModule,
        ExternalModule,
        PipesModule,
        DirectivesModule,
        FormsModule,
        ReactiveFormsModule,
        ScrollingModule,
        NgxChartsModule,
        NgScrollbarModule,
        NzPipesModule,
        NzDividerModule,
        NzInputNumberModule,
        AngularEditorModule,
        NgxEditorModule,
        NgxDocViewerModule,
        PdfViewerModule,
        NgxMasonryModule,
        DragDropModule,
    ],
  exports: components,
  providers: [
    LinkAnnotationService,
    BookmarkViewService,
    MagnificationService,
    ThumbnailViewService,
    ToolbarService,
    NavigationService,
    TextSearchService,
    TextSelectionService,
    PrintService,
    RequiredMeasurementsTranslatePipe,
    VerifyRequiredMeasurementsPipe
  ]
})
export class ComponentsModule { }
